import {
  BMButtonIcon,
  BMComponentsType,
  BMPrimitives,
  BMText,
  BMTray,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcSystemContactMessageCs from "@traveloka/icon-kit-web/react/IcSystemContactMessageCs";
import IcSystemCrossClose from "@traveloka/icon-kit-web/react/IcSystemCrossClose";
import { FC, useState } from "react";
import { Image, Pressable, StyleSheet } from "react-native";
import { CUSTOMER_CARE_ILLUSTRATION } from "../../../assets/cs";
import { ENVELOP_ILLUSTRATION } from "../../../assets/envelop";
import BMView from "../../../components/View/BMView";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";

type Props = {
  onClickCallCenter?: () => void;
  onClickEmail?: () => void;
};

export default function CustomerServiceWidget({
  onClickCallCenter,
  onClickEmail,
}: Props) {
  const [visible, setVisible] = useState(false);

  const { BMComponents } = useBMTheme();
  const { CorporateCommon: cr, CorporateNavigationProfileWidget: crp } =
    useMobileContentResource();

  const styles = createStyles(BMComponents);
  return (
    <BMView>
      <Pressable onPress={() => setVisible(true)} testID="cs_button">
        <IcSystemContactMessageCs
          width={24}
          height={24}
          color={BMComponents.BMStyleSurfaceBgcolor}
        />
      </Pressable>
      <BMTray
        isVisible={visible}
        onTrayClose={() => setVisible(false)}
        fitContent
      >
        <BMView spacing="lg">
          <BMView
            flex
            row
            justify="between"
            align="center"
            style={styles.container}
          >
            <BMText variant="titleNormal">{crp.csTitleWidget}</BMText>
            <BMButtonIcon
              Icon={IcSystemCrossClose}
              onPress={() => setVisible(false)}
            />
          </BMView>
          <BMView spacing="md">
            <CSInfoCard
              label={crp.callCenterLabel}
              description={cr.corporateB2BPhone}
              Illustration={() => (
                <Image
                  source={{ uri: CUSTOMER_CARE_ILLUSTRATION }}
                  style={{ width: 40, height: 40 }}
                />
              )}
              onPress={onClickCallCenter}
            />
            <CSInfoCard
              label={crp.emailLabel}
              description={cr.corporateB2BEmail}
              Illustration={() => (
                <Image
                  source={{ uri: ENVELOP_ILLUSTRATION }}
                  style={{ width: 40, height: 40 }}
                />
              )}
              onPress={onClickEmail}
            />
          </BMView>
        </BMView>
      </BMTray>
    </BMView>
  );
}

type CSInfoCardProps = {
  label: string;
  description: string;
  Illustration: FC;
  onPress?: () => void;
};

function CSInfoCard({
  label,
  description,
  Illustration,
  onPress,
}: CSInfoCardProps) {
  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);
  return (
    <Pressable onPress={onPress}>
      <BMView spacing="md" row align="center" style={styles.card}>
        <Illustration />
        <BMView>
          <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondaryInvert">
            {label}
          </BMText>
          <BMText variant="uiLarge" ink="BMStyleTextInkAction">
            {description}
          </BMText>
        </BMView>
      </BMView>
    </Pressable>
  );
}

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    container: {
      marginTop: BMPrimitives.BMSize.xs,
    },
    card: {
      padding: BMPrimitives.BMSize.sm,
      borderRadius: BMPrimitives.BMRadius.md,
      borderWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMPrimitives.BMBrand.primaryLight,
      backgroundColor: BMComponents.BMStyleSurfaceBgcolorInventory,
    },
  });
}
